import React from 'react';
import AddSessionsModal from './modals/addSessionsModal';
import RemoveSessionsModal from './modals/removeSessionsModal';
import ViewsTable from '../../../components/tables/ViewsTable';
import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import InputField from '../../../components/inputs/inputField';
import { UncontrolledTooltip } from 'reactstrap';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';

class InventorySessions extends React.Component {
    constructor(props) {
        super(props);
        const columns = {
            name: 'Name',
        };
        const columnTypes = {
            name: 'string',
        };
        const toggledColumns = {};
        const normalizedColumns = Object.keys(columns).map((cfc) => {
            toggledColumns[cfc] = true;
            return {
                label: columns[cfc],
                key: cfc,
                value: cfc,
                type: columnTypes[cfc],
                sortAsc: false,
                sortDesc: false
            };
        });
        this.state = {
            columns: columns,
            columnTypes: columnTypes,
            normalizedColumns: normalizedColumns,
            toggledColumns: toggledColumns,
            checkedSessions: {},
            selectedColumnSort: null,
            sortDesc: false,
            searchTerm: '',
            toggleAddSessions: false,
            toggleRemoveSessions: false,
        };
    }

    toggleAddSessions = () => {
        this.setState({ toggleAddSessions: !this.state.toggleAddSessions });
    };

    toggleRemoveSessions = (sessions) => {
        this.setState(
            {
                toggleRemoveSessions: !this.state.toggleRemoveSessions,
            }
        );
    };


    /* Search */
    searchEntries = (searchText) => {
        this.setState({
            searching: searchText != '' ? true : false,
            searchText: searchText ? searchText : '',
        });
    };
    /* Download */
    s2ab = (s) => {
        var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf); //create uint8array as viewer
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
        return buf;
    };
    downloadReport = async () => {

        const { columns, columnTypes } = this.state;
        let sessions = this.props.editedItem.bookedBy;
        const entries = sessions; //selectedCustomView ? organizedEntries : allEntries;
        const dataRows = [];
        entries.forEach((entry) => {
            const dataRow = {};
            Object.keys(columns).forEach((hc) => {
                if (entry[hc] != null) {
                    if (columnTypes[hc] === 'boolean' || columnTypes[hc] === 'bool') {
                        dataRow[hc] = entry[hc] ? 'Yes' : 'No';
                    } else {
                        dataRow[hc] = entry[hc];
                    }
                }
            });
            dataRows.push(dataRow);
        });
        const cleanData = [];
        const headers = Object.keys(columns).map((header, hIndex) => {
            dataRows.forEach((data, dIndex) => {
                if (!cleanData[dIndex]) cleanData[dIndex] = [];
                cleanData[dIndex][hIndex] = data[header] || '';
            });
            return columns[header];
        });
        const data = {
            headerRow: headers,
            dataRows: cleanData
        };

        const reportDetails =
            { Title: this.props.editedItem.name + " Report", Subject: 'Inventory Session Report ' };
        this.downloadRegular(reportDetails, data);
    };

    downloadRegular = (report, data) => {
        var wb = XLSX.utils.book_new();
        wb.Props = {
            Title: report.Title,
            Subject: report.Subject,
            Author: 'Simple Events',
            CreatedDate: new Date()
        };
        wb.SheetNames.push('Data');
        /* make worksheet */
        var ws_data2 = [data.headerRow, ...data.dataRows];
        var ws2 = XLSX.utils.aoa_to_sheet(ws_data2);

        /* Add the worksheet to the workbook */
        wb.Sheets['Data'] = ws2;

        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        saveAs(
            new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
            `${report.Title}_${moment().format('LLL')}.xlsx`
        );
    };
    sortData = (column, sortAsc, sortDesc) => {
        const { normalizedColumns } = this.state;
        const updatedColumns = normalizedColumns.map((col) => {
            if (col.key == column.key) {
                col.sortAsc = sortAsc;
                col.sortDesc = sortDesc;
            } else {
                col.sortAsc = false;
                col.sortDesc = false;
            }
            return col;
        });

        this.setState({
            normalizedColumns: updatedColumns,
            selectedColumnSort: column,
            sortDesc: sortDesc ? true : false
        });
    };

    updateChecked = (checked) => {
        this.setState({ checkedSessions: checked });

    };

    removeBookedBySessions = (sessions) => {
        this.setState({
            checkedSessions: {}
        }, () => {
            this.props.removeBookedBySessions(sessions);
        });
    }



    render() {
        const { searchTerm, normalizedColumns, toggledColumns, selectedColumnSort, sortDesc, columns, toggleAddSessions } = this.state;
        let sessions = this.props.editedItem.bookedBy;
        let data = sessions;
        if (searchTerm.length > 0) {
            const searchTerms = searchTerm.toLowerCase().split(' ');
            searchTerms.forEach((term) => {
                if (term != '') {
                    data = data.filter((entry) => {
                        let found = false;
                        Object.keys(columns).forEach((key) => {
                            if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
                                found = true;
                            }
                        });
                        return found;
                    });
                }
            });
        }
        if (selectedColumnSort) {
            data = data.sort((a, b) => {
                const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                    switch (columnType) {
                        case 'string':
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                        case 'number':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        case 'date':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'time':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'boolean':
                            const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                            const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                            return a1.localeCompare(b1);
                        default:
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                    }
                } else if (a[selectedColumnSort.key]) {
                    return 1;
                }
                return -1;
            });

            data = sortDesc ? data.reverse() : data;
        }

        let batchActions = [
            {
                type: 'button',
                label: 'Remove From Inventory',
                onClick: this.toggleRemoveSessions,
                iconClass: 'las la-trash-alt',
                class: 'danger'
            }
        ]
        return (
            <div className="sectionBody3 posRel mb-0 p-0">
                <div className="actionButtonContainer headerHeight flex-ac">
                    <ActionButtonContainer
                        mainActions={[{ onClick: this.toggleAddSessions, label: 'Add Sessions' }]}
                    />
                    <InputField
                        classes="m-0 viewSearch"
                        placeholder="Search "
                        clickIcon={true}
                        required={true}
                        value={searchTerm}
                        onChange={(e) => {
                            clearTimeout(this.searchTimeout);
                            this.setState({ searchTerm: e.target.value },
                                () => {
                                    this.searchTimeout = setTimeout(() => this.searchEntries(this.state.searchTerm), 1000);
                                });

                        }}
                        prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
                        inputIcon={searchTerm != '' &&
                            <i
                                onMouseDown={() => this.setState({ searchTerm: '', searching: false }, () => this.searchEntries(''))}
                                className="las la-times-circle"
                                style={{ visibility: searchTerm == '' ? 'hidden' : 'visible' }}
                            />}
                    />
                    <div className="sectionOptionsContainer">
                        <div id="downloadTable" className='c-pointer fs-20' onClick={() => this.downloadReport()}>
                            <i className="las la-download" />
                            <UncontrolledTooltip target="downloadTable" placement="left">Download Table Data</UncontrolledTooltip>
                        </div>
                    </div>
                </div>
                <ViewsTable
                    title="Sessions"
                    style={{ margin: 0 }}
                    columns={normalizedColumns}
                    toggledColumns={toggledColumns}
                    data={data}
                    mainColumnActive={false}
                    checked={this.state.checkedSessions}
                    checkRow={(entryId) => {
                        const checked = this.state.checkedSessions;
                        checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
                        this.updateChecked(checked);
                        this.setState({
                            checkedSessions: checked
                        });
                    }}
                    checkAllRows={(entryIds) => {
                        let checked = this.state.checkedSessions;
                        entryIds.length > 0
                            ? entryIds.forEach((entryId) => {
                                checked[entryId] = true;
                            })
                            : (checked = {});
                        this.updateChecked(checked);

                        this.setState({
                            checkedSessions: checked
                        });
                    }}
                    sortData={this.sortData}
                />


                <ActionButtonContainer
                    mainActions={[]}
                    batchActions={batchActions}
                    checkedEntryCount={Object.keys(this.state.checkedSessions).length}
                    entriesLength={sessions.length}
                    uncheckEntries={() => {
                        //this.updateChecked({});
                        this.setState({
                            checkedSessions: {}
                        });
                    }}
                />
                {toggleAddSessions && (
                    <AddSessionsModal
                        isOpen={toggleAddSessions}
                        toggle={this.toggleAddSessions}
                        existingSessions={sessions}
                        editedItem={this.props.editedItem}
                        sessions={this.props.event.sessions}
                        eventId={this.props.event._id}
                        orgId={this.props.orgId}
                        addBookedBySessions={this.props.addBookedBySessions}
                    />
                )}
                {this.state.toggleRemoveSessions && (
                    <RemoveSessionsModal
                        isOpen={this.state.toggleRemoveSessions}
                        toggle={this.toggleRemoveSessions}
                        existingSessions={sessions}
                        orgId={this.props.orgId}
                        eventId={this.props.event._id}
                        editedItem={this.props.editedItem}
                        checkedSessions={this.state.checkedSessions}
                        removeBookedBySessions={this.removeBookedBySessions}
                    />
                )}

            </div>
        );
    }
}

export default InventorySessions;
